<template>
    <div style="display: flex; flex-direction: column;" id="agreement_contents_print_wrap_contract">
        <div style="flex: 1; padding: 20px; overflow-y: scroll;">
            <div ref="wrapper" style="">
                <div style="text-align: center; font-weight: 700; margin-bottom: 20px; font-size: 18px;">일용직 근로 계약서</div>
                <div style="line-height: 24px;">본 계약은 일용직 근로자의 고용, 개인정보 제공, 안전 준수에 대한 내용을 포함하며, 아래와 같은 조건에 따라 체결됩니다.</div>
                <div style="margin-top: 20px;">
                    <div class="title">1. 근로계약서</div>
                    <div class="sub_title_wrapper">
                        <div class="sub_title">[근로자 정보]</div>
                        <div class="list_wrapper">
                            <div class="list_contents">1. 이름: {{name}}</div>
                            <div class="list_contents">2. 주민등록번호(또는 생년월일): {{jumin}}</div>
                            <div class="list_contents">3. 연락처: {{phone}}</div>
                            <div class="list_contents">4. 임금지급 계좌번호: (은행) {{bank_name}} {{bank_account}}</div>
                        </div>
                    </div>
                    <div class="sub_title_wrapper">
                        <div class="sub_title">[고용주 정보]</div>
                        <div class="list_wrapper">
                            <div class="list_contents">1. 사업체명: 주식회사 미누워크</div>
                            <div class="list_contents">2. 주소: 경기도 평택시 청북읍 고렴산단로 133</div>
                            <div class="list_contents">3. 대표자명: 서기성</div>
                        </div>
                    </div>
                    <div class="sub_title_wrapper">
                        <div class="sub_title">[근로 조건]</div>
                        <div class="list_wrapper">
                            <div class="list_contents">1. 근무 내용: 화장품 제품 포장 및 물류 이동</div>
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">2.</div>
                                <div style="margin-left: 0;" class="list_wrapper">
                                    <div class="list_contents">가. 근무 일자: {{$Util.getMDDHangulStr(work_date)}}</div>
                                    <div style="display: flex; gap: 3px; align-items: flex-start;" class="list_contents">
                                        <div style="line-height: 18px;">나.</div>
                                        <div style="line-height: 18px;">근로 시간: {{begin_time.substr(0, 2)}}시 ~ {{end_time.substr(0, 2)}}시 (총 휴게시간 포함 {{time_diff}}시간)</div>
                                    </div>
                                    <div class="list_contents">다. 중간 휴게 시간: 10:30 ~ 10:45 , 15:30 ~ 15:45 (총 30분) , 점심시간: 12:30~13:30(1시간)</div>
                                </div>
                            </div>
                            <div class="list_contents">3. 임금 조건: 일당 {{pay | comma}}원(세후, 주휴수당 포함)</div>
                            <div class="list_contents">4. 추가 근로 시 가산 금액: 주간 근로의 1.5배 지급</div>
                            <div class="list_contents">
                                <div style="margin-bottom: 6px;">5. 임금 지급 방식</div>
                                <div style="display:flex;">
                                    <div style="display:flex; align-items: center; padding:5px 0px;" @click="setPayType('계좌이체')">
                                        <div style="position:relative; border-radius:50%; width:20px; height:20px; border:1px solid #BBBBBB;">
                                            <div v-if="formData.pay_type === '계좌이체'" style="width:14px; height:14px; border-radius:50%; background-color: #2196F3; position:absolute; left:2px; top:2px;"></div>
                                        </div>
                                        <div style="margin-left:5px; color:#210F03;font-weight:500;">계좌 이체</div>
                                    </div>
                                    <div style="display:flex; align-items: center; padding:5px 0px; margin-left:10px;" @click="setPayType('현금지급')">
                                        <div style="position:relative; border-radius:50%; width:20px; height:20px; border:1px solid #BBBBBB;">
                                            <div v-if="formData.pay_type === '현금지급'" style="width:14px; height:14px; border-radius:50%; background-color: #2196F3; position:absolute; left:2px; top:2px;"></div>
                                        </div>
                                        <div style="margin-left:5px; color:#210F03;font-weight:500;">현금 지급</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sub_title_wrapper">
                        <div class="sub_title">[기타 사항]</div>
                        <div class="list_wrapper">
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">1.</div>
                                <div style="line-height: 24px;">본 계약은 일용직 근로자로서 계약 종료 후 추가 고용 의무가 없습니다.</div>
                            </div>
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">2.</div>
                                <div style="line-height: 24px;">근로자는 작업 중 안전 수칙을 준수하며, 사고 발생 시 즉시 보고해야 합니다.</div>
                            </div>
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">3.</div>
                                <div style="line-height: 24px;">근로자는 업무 수행 중 관리자(또는 회사 대표)의 정당한 지시와 감독을 성실히 이행하여야 합니다.</div>
                            </div>
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">4.</div>
                                <div style="line-height: 24px;">근로자가 관리자의 정당한 지시를 따르지 않거나 근무 태도가 불량하다고 판단될 경우, 회사는 해당 근로자의 업무를 즉시 중단시킬 수 있으며, 이 경우 실제 근무한 시간만을 기준으로 근로시간을 계산하여 임금을 지급합니다.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title">2. 개인정보 수집 및 이용 동의</div>
                    <div style="margin-bottom: 10px;" class="sub_title_wrapper">
                        <div class="sub_title">[개인정보 수집 항목 및 목적]</div>
                        <div class="list_wrapper">
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">1.</div>
                                <div style="line-height: 24px;">수집 항목: 이름, 주민등록번호(또는 생년월일), 연락처, 계좌번호</div>
                            </div>
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">2.</div>
                                <div style="margin-left: 0; gap: 5px;" class="list_wrapper">
                                    <div style="line-height: 24px;">수집 및 이용 목적:</div>
                                    <div class="list_contents">가. 근무 일자: {{$Util.getMDDHangulStr(work_date)}}</div>
                                    <div style="display: flex; gap: 3px; align-items: flex-start;" class="list_contents">
                                        <div style="line-height: 18px;">나.</div>
                                        <div style="line-height: 18px;">근로 시간: {{begin_time.substr(0, 2)}}시 ~ {{end_time.substr(0, 2)}}시 (총 휴게시간 포함 {{time_diff}}시간)</div>
                                    </div>
                                    <div class="list_contents">다. 중간 휴게 시간: 10:30 ~ 10:45 , 15:30 ~ 15:45 (총 30분) , 점심시간: 12:30~13:30(1시간)</div>
                                </div>
                            </div>
                            <div class="list_contents">3. 보관 기간: 근무 종료 후 1년 (법적 의무 기간) </div>
                            <div class="list_contents">4. 개인정보 제3자 제공 여부: 없음</div>
                        </div>
                    </div>
                    <div style="display:flex;">
                        <div style="display:flex; align-items: center; padding:5px 0px;" @click="setIsAgree('동의함')">
                            <div style="position:relative; border-radius:50%; width:20px; height:20px; border:1px solid #BBBBBB;">
                                <div v-if="formData.isAgree === '동의함'" style="width:14px; height:14px; border-radius:50%; background-color: #2196F3; position:absolute; left:2px; top:2px;"></div>
                            </div>
                            <div style="margin-left:5px; color:#210F03;font-weight:500;">동의함</div>
                        </div>
                        <div style="display:flex; align-items: center; padding:5px 0px; margin-left:10px;" @click="setIsAgree('동의하지 않음')">
                            <div style="position:relative; border-radius:50%; width:20px; height:20px; border:1px solid #BBBBBB;">
                                <div v-if="formData.isAgree === '동의하지 않음'" style="width:14px; height:14px; border-radius:50%; background-color: #2196F3; position:absolute; left:2px; top:2px;"></div>
                            </div>
                            <div style="margin-left:5px; color:#210F03;font-weight:500;">동의하지 않음</div>
                        </div>
                    </div>
                    <div style="margin-top: 10px;">
                        <div style="margin-top:10px;">
                            <div>
                                <div style="margin-bottom: 10px;">마우스/손 으로 서명해주세요</div>
                                <canvas ref="signCanvas1" id="signCanvas1" style="background-color: rgba(200,200,200, 0.5); width: 100%; border-radius: 4px;"></canvas>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 30px;">
                    <div class="title">3. 안전 준수 서약</div>
                    <div style="margin-bottom: 10px;" class="sub_title_wrapper">
                        <div class="sub_title">[안전 준수 내용]</div>
                        <div style="line-height: 24px; margin-bottom: 10px;">본인은 주식회사 미누워크 공장에서 작업을 수행함에 있어 아래 사항을 준수할 것을 서약합니다.</div>
                        <div class="list_wrapper">
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">1.</div>
                                <div style="line-height: 24px;">작업 시작 전 안전 교육 내용을 충분히 숙지하겠습니다.</div>
                            </div>
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">2.</div>
                                <div style="line-height: 24px;">공장에서 제공한 안전 장비를 착용하며, 안전 수칙을 준수하겠습니다.</div>
                            </div>
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">3.</div>
                                <div style="line-height: 24px;">위험 지역(작업 외 구역)에 접근하지 않겠습니다.</div>
                            </div>
                            <div class="list_contents list_contents_flex">
                                <div style="line-height: 24px;">4.</div>
                                <div style="line-height: 24px;">작업 중 사고 발생시 즉시 보고하고 적절히 조치하겠습니다</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="sub_title">[책임 사항]</div>
                        <div style="line-height: 24px; margin-bottom: 10px;">위 사항을 준수하지 않아 발생한 사고에 대해서는 본이느이 책임이 따를 수 있음을 확인합니다.</div>
                        <div style="font-weight: 700; margin-bottom: 20px;">첨부: 근로자 신분증 사본 1부</div>
                        <div style="text-align: center;">{{ $Util.getYYYMMDDHangulStr(today) }}</div>
                    </div>
                    <div style="margin-top: 20px;">
                        <div>근로자 이름: {{name}}</div>
                        <div style="margin-top: 10px;">
                            <div style="margin-top:10px;">
                                <div>
                                    <div style="margin-bottom: 10px;">마우스/손 으로 서명해주세요</div>
                                    <canvas ref="signCanvas2" id="signCanvas2" style="background-color: rgba(200,200,200, 0.5); width: 100%; border-radius: 4px;"></canvas>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 10px;">고용주 서명: 주식회사 미누워크 대표이사 서기성 (인)</div>
                    </div>
                    <div style="margin-top: 20px;">
                        <ProgressButton buttonText="제출" style="margin-top:0px;" />
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" :value="JSON.stringify(agree_str)" id="checkbox_arr_str_contract">
    </div>
</template>

<script>
import moment from "moment"
import ProgressButton from "@/components/common/ProgressButton";

export default {
    name: "ContractAgreementContents",
    components: {
        ProgressButton
    },
    props : {},
    computed: {
        agree_str() {
            return this.formData
        }
    },
    data() {
        return {
            today: '',
            formData: {
                pay_type: '',
                isAgree: '',
                isSigned1: false,
                isSigned2: false,
                pageHeight: 0
            },
            name : '',
            jumin : '',
            phone : '',
            bank_name : '',
            bank_account : '',
            work_date : '',
            begin_time : '',
            end_time : '',
            pay : '',
            time_diff : '',
        }
    },
    methods: {
        setPayType(payType) {
            this.formData.pay_type = payType;
        },
        setIsAgree(isAgree) {
            this.formData.isAgree = isAgree;
        },
        createSignatureCanvas(canvasRefName, canvasNum) {
            const that = this;
            const canvas = this.$refs[canvasRefName];  // <canvas ref="signCanvas" /> 이런 식으로 되어 있어야 함
            const div = canvas.parentElement;
            const ctx = canvas.getContext("2d");
            let drawble = false;

            function canvasResize() {
                canvas.width = div.clientWidth;
                canvas.height = div.clientHeight;
            }

            function getMousePosition(e) {
                const rect = canvas.getBoundingClientRect();
                return {
                    X: e.clientX - rect.left,
                    Y: e.clientY - rect.top
                };
            }

            function draw(e) {
                const pos = getMousePosition(e);
                switch (e.type) {
                    case "mousedown":
                        that.formData['isSigned' + canvasNum] = true;
                        drawble = true;
                        ctx.beginPath();
                        ctx.moveTo(pos.X, pos.Y);
                        break;
                    case "mousemove":
                        if (drawble) {
                            ctx.lineTo(pos.X, pos.Y);
                            ctx.stroke();
                        }
                        break;
                    case "mouseup":
                    case "mouseout":
                        drawble = false;
                        ctx.closePath();
                        break;
                }
            }

            function getTouchPosition(e) {
                const rect = canvas.getBoundingClientRect();
                return {
                    X: e.touches[0].clientX - rect.left,
                    Y: e.touches[0].clientY - rect.top
                };
            }
        
            function touchDraw(e) {
                const pos = getTouchPosition(e);
                switch (e.type) {
                    case "touchstart":
                        that.formData['isSigned' + canvasNum] = true;
                        drawble = true;
                        ctx.beginPath();
                        ctx.moveTo(pos.X, pos.Y);
                        break;
                    case "touchmove":
                        if (drawble) {
                            e.preventDefault();
                            ctx.lineTo(pos.X, pos.Y);
                            ctx.stroke();
                        }
                        break;
                    case "touchend":
                    case "touchcancel":
                        drawble = false;
                        ctx.closePath();
                        break;
                }
            }
        
            return {
                init: function () {
                    canvas.addEventListener("mousedown", draw);
                    canvas.addEventListener("mousemove", draw);
                    canvas.addEventListener("mouseup", draw);
                    canvas.addEventListener("mouseout", draw);
                
                    canvas.addEventListener("touchstart", touchDraw);
                    canvas.addEventListener("touchmove", touchDraw);
                    // canvas.addEventListener("touchend", touchDraw);
                    canvas.addEventListener("touchcancel", touchDraw);
                },
                onLoad: function () {
                    canvasResize();
                }
            };
        },
        async getWorkInfo(){
            const res = await this.$Axios.get('/api/agreement/work/info');
            const member = res.data.member;
            const work_calendar = res.data.work_calendar;
            this.name = member.name;
            this.jumin = member.jumin;
            this.phone = member.phone;
            this.bank_name = member.bank_name;
            this.bank_account = member.bank_account;

            this.work_date = work_calendar.work_date;
            this.begin_time = work_calendar.begin_time;
            this.end_time = work_calendar.end_time;
            this.pay = work_calendar.pay;
            this.time_diff = parseInt(work_calendar.end_time.substr(0, 2)) - parseInt(work_calendar.begin_time.substr(0, 2));

        }
    },
    mounted() {
        const sign1 = this.createSignatureCanvas('signCanvas1', 1);
        const sign2 = this.createSignatureCanvas('signCanvas2', 2);

        sign1.init();
        sign2.init();

        sign1.onLoad();
        sign2.onLoad();
        this.$nextTick(() => {
            this.formData.pageHeight = this.$refs.wrapper.scrollHeight
        })
    },
    created() {
        const today = moment().format('YYYY-MM-DD')
        this.today = today

        this.getWorkInfo();
    }
}
</script>

<style scoped>
.sub_title_wrapper {
    margin-bottom: 20px;
}

.list_wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-left: 12px;
}

.list_contents {
    line-height: 24px;
}

.list_contents_flex {
    display: flex;
    gap: 4px;
}

.title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
}

.sub_title {
    margin-top: 8px;
    margin-bottom: 10px;
    font-weight: 500;
}

.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
}


select {
    width: 100%;
    padding: 0px 6px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
    background-color: white;
    color: black;
}

button {
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: 44px;
}

button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}
</style>